import Vue from "vue"
import Vuex from "vuex"
import users from './usersStore'
import home from './homeStore'

//状态管理 注入主件
Vue.use(Vuex)
const state = {
}

const getters = {
    userInfo: state => state.users.userInfo,
    publicMenu: state => state.users.publicMenu,
    otherData: state => state.users.otherData,
}
const mutations = {
}
const actions = {

    
}
export default new Vuex.Store({
    state,getters,mutations,actions,
    modules:{
        users,home
    }
})


// WEBPACK FOOTER //
// ./src/store/store.js